export const statusMixin = {
  methods: {
    getStatusTitle(statusCode) {
      switch (Number(statusCode)) {
        case 0:
          return {
            status: 'Active',
            code: statusCode,
          };

        case 1:
          return {
            status: 'Submitted',
            code: statusCode,
          };
        case 2:
          return {
            status: 'Approved',
            code: statusCode,
          };

        case 3:
          return {
            status: 'Published',
            code: statusCode,
          };
        case 4:
          return {
            status: 'Rejected',
            code: statusCode,
          };
        case 5:
          return {
            status: 'Closed',
            code: statusCode,
          };

        default:
          return {
            status: '',
            code: '',
          };
      }
    },
    getStatusColorClass(statusCode) {
      /*   public const JOBAD_STATUS_ACTIVE = 0;
      public const JOBAD_STATUS_SUBMITTED = 1;
      public const JOBAD_STATUS_APPROVED = 2;
      public const JOBAD_STATUS_PUBLISHED = 3;
      public const JOBAD_STATUS_REJECTED = 4;
      public const JOBAD_STATUS_CLOSED = 5; */

      let statusColorClass;

      switch (Number(statusCode)) {
        case 0:
          statusColorClass = 'job-status-color-active';
          break;

        case 1:
          statusColorClass = 'job-status-color-submitted';
          break;

        case 2:
          statusColorClass = 'job-status-color-approved';
          break;

        case 3:
          statusColorClass = 'job-status-color-published';
          break;

        case 4:
          statusColorClass = 'job-status-color-rejected';
          break;

        case 5:
          statusColorClass = 'job-status-color-closed';
          break;

        case 6:
          statusColorClass = 'job-status-colornot-submitted';
          break;

        default:
          statusColorClass = 'color-default';
          break;
      }

      return statusColorClass;
    },
  },
};
